<template>
  <z-card class="widget-search-cta">
    <z-title
      class="widget-search-cta__title"
      size="small"
      align="left"
    >
      {{ $t('title') }}
    </z-title>

    <z-text
      class="widget-search-cta__paragraph"
      tag="p"
    >
      {{ $t('paragraph') }}
    </z-text>

    <ul class="widget-search-cta__list">
      <li
        v-for="item in itemList"
        :key="item.text"
        class="widget-search-cta__list-item"
      >
        <z-icon :icon="item.icon" />

        <z-text>{{ item.text }}</z-text>
      </li>
    </ul>

    <form
      class="widget-search-cta__form"
      @submit.prevent="onSubmit"
    >
      <z-input-field
        label="Qual curso você quer fazer?"
        for="course-selector"
        class="widget-search-cta__autocomplete"
      >
        <z-input
          v-model="course"
          placeholder="Digite o curso"
        />
      </z-input-field>

      <div class="price-slider__label-wrapper">
        <z-text
          tag="p"
          class="price-slider__label-how-much-can-pay"
          align="left"
          weight="medium"
        >
          {{ $t('form-course-autocomplete-label') }}
        </z-text>

        <z-text
          color="major"
          tag="span"
          align="left"
        >
          {{ formattedPrice }}
        </z-text>
      </div>

      <z-slider
        v-model="price"
        :min="0"
        :max="10000"
        class="z-mt-0500"
        :range="{
          'min': [0],
          '50%': [1000],
          '75%': [2000],
          'max': [10000],
        }"
      />
      <z-button
        tag="a"
        :href="plpUrl"
        variant="secondary"
        class="widget-search-cta__submit"
      >
        {{ $t('form-submit-button') }}
      </z-button>
    </form>
  </z-card>
</template>

<script>
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons'
import { round } from 'lodash'

const INITIAL_PRICE = 5000

export default {
  name: 'WidgetSearchCta',
  data () {
    return {
      price: INITIAL_PRICE,
      course: '',
      itemList: [
        {
          icon: faCircleCheck,
          text: 'Você encontra sua vaga',
        },
        {
          icon: faCircleCheck,
          text: 'A bolsa vale até o final do curso',
        },
        {
          icon: faCircleCheck,
          text: 'Bolsa garantida ou seu dinheiro de volta',
        },
      ],
    }
  },
  computed: {
    formattedPrice () {
      const options = {}
      options.minimumFractionDigits = 0
      options.maximumFractionDigits = 0

      return round(this.price, 2)
        .toLocaleString('pt-BR', {
          currency: 'BRL',
          style: 'currency',
          ...options,
        })
    },
    plpUrl () {
      return `https://querobolsa.com.br/busca-cursos/resultados?c=${this.course}&pr=${this.price}`
    },
  },
  i18n: {
    messages: {
      'pt-BR': require('./i18n/widget-search_cta.json'),
    },
  },
}
</script>

<style lang="scss" scoped>
.widget-search-cta {
  display: grid;
  grid-template-areas:
    (
      'title'
      'paragraph'
      'list'
      'form'
    );

  @media (min-width: $breakpoint-desktop) {
    column-gap: var(--unit-0800);
    grid-template-areas:
      (
        'title     form'
        'paragraph form'
        'list      form'
      );
    grid-template-columns: repeat(2, 1fr);
  }
}

.widget-search-cta__title {
  grid-area: title;
  max-width: 320px;
}

.widget-search-cta__paragraph {
  grid-area: paragraph;
  margin-bottom: var(--unit-0000);
  margin-top: var(--unit-0200);
}

.widget-search-cta__list {
  display: grid;
  grid-area: list;
  list-style: none;
  margin-bottom: var(--unit-0000);
  margin-top: var(--unit-0600);
  padding-left: var(--unit-0000);
  row-gap: var(--unit-0400);
}

.widget-search-cta__list-item {
  align-items: flex-start;
  column-gap: var(--unit-0200);
  display: grid;
  grid-template-columns: min-content auto;

  @media (min-width: $breakpoint-desktop) {
    align-items: center;
  }
}

.widget-search-cta__form {
  grid-area: form;
  margin-top: var(--unit-0600);

  @media (min-width: $breakpoint-desktop) {
    margin-top: var(--unit-0000);
  }
}

.widget-search-cta__autocomplete {
  margin-bottom: var(--unit-0000);
}

.widget-search-cta__submit {
  margin-top: var(--unit-0600);
  width: 100%;

  @media (min-width: $breakpoint-desktop) {
    float: right;
    width: auto;
  }
}

.price-slider__label-wrapper {
  display: flex;
  flex-direction: column;
  margin-right: var(--unit-0400);
}
</style>
